// Global
import React from 'react';

// Local
import { RecipeResponse } from 'lib/services/models/content-response';

import styles from './RecipeDescription.module.scss';
import EnhancedRichText from 'components/helpers/Atoms/EnhancedRichText/EnhancedRichText';

export interface RecipeDescriptionProps {
  recipe?: RecipeResponse;
}

export function RecipeDescription(props: RecipeDescriptionProps) {
  const recipe = props.recipe;

  if (!recipe) {
    return <></>;
  }

  return (
    <div className={styles.recipeDescriptionWrapper}>
      <EnhancedRichText className={styles.recipeDescription} value={recipe.Description} />
    </div>
  );
}
